import { EpicRefined } from 'interfaces/middleware'
import { FloatingPaneAction, MODIFY_FLOATING_PANE, KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES } from 'actions/floatingPanesActions'
import { byType } from 'rxOperators/byType'
import { mergeMap, switchMap, take, map } from 'rxjs/operators'
import { pushActionCreator, PushAction } from 'actions/navigationActions'
import { DASHBOARD_URL } from 'tangle-shared'
import { EMPTY, of, merge } from 'rxjs'


export const finishSignupEpic: EpicRefined<FloatingPaneAction | PushAction> = (action$) => action$.pipe(
  byType(MODIFY_FLOATING_PANE),
  mergeMap(({ payload }) => {
    if (payload.type === 'advisor' && payload.mode === 'request' && payload.step === 'confirmed' && payload.fields.flow !== 'regular') {
      return of(payload)
    }
    return EMPTY
  }),
  switchMap(() =>
    merge(
      action$.pipe(byType(MODIFY_FLOATING_PANE)),
      action$.pipe(byType(KILL_ALL_FLOATING_PANES)),
      action$.pipe(byType(KILL_FLOATING_PANES)),
    ).pipe(
      take(1),
      map(() => pushActionCreator(DASHBOARD_URL))
    )
  ),
)
